import {ReactNode} from "react";
import {css} from "@panda/css";

interface IProps {
    children: ReactNode;
}

export const ResponsiveTable = (props: IProps) => {
    const {children} = props;

    return (
        <div className={responsiveTableWrapper}>
            <table className={responsiveTable}>
                <tbody className={responsiveTableBody}>{children}</tbody>
            </table>
        </div>
    );
};

const responsiveTableWrapper = css({
    sm: {
        mx: 4
    }
});

const responsiveTable = css({
    display: "block",
    width: "100%",
    borderCollapse: "collapse",

    sm: {
        display: "table",
        tableLayout: "fixed"
    }
});

const responsiveTableBody = css({
    display: "block",
    width: "100%",

    sm: {
        display: "table-row-group"
    }
});
import {ReactNode} from "react";
import {css} from "@panda/css";

interface IProps {
    children: ReactNode;
}

export const ResponsiveTable = (props: IProps) => {
    const {children} = props;

    return (
        <div className={responsiveTableWrapper}>
            <table className={responsiveTable}>
                <tbody className={responsiveTableBody}>{children}</tbody>
            </table>
        </div>
    );
};

const responsiveTableWrapper = css({
    sm: {
        mx: 4
    }
});

const responsiveTable = css({
    display: "block",
    width: "100%",
    borderCollapse: "collapse",

    sm: {
        display: "table",
        tableLayout: "fixed"
    }
});

const responsiveTableBody = css({
    display: "block",
    width: "100%",

    sm: {
        display: "table-row-group"
    }
});
